<template>
  <div>
    <div id="pswrapper">
      <p>
        CHRS has replaced myHR.  Click the link below to log in using your CSUB email and password.
      </p>
      <p v-if="allowLogin">
        <a :href="buttonLoc" class="btn">Click here to log into CHRS</a>
      </p>
      <p v-else>
        <button class="btn btn-secondary" disabled>Maintenance currently in progress.</button>
      </p>
      <hr />
    </div>
    <div class="maint">
      <p v-html="maintMessage"></p>
      <p v-if="secondary_message">{{ secondary_message }}</p>
    </div>
  </div>
</template>

<script>
// import { main } from '@popperjs/core';
import axios from 'axios'

export default {
  name: 'maint',
  data () {
    return {
      buttonLoc: '',
      useDefaultMaintMsg: Boolean,
      maintMessage: '',
      maintenanceDay: '',
      maintenance_start_hour: '',
      maintenance_end_hour: '',
      secondary_message: '',
      allowLogin: Boolean
    }
  },

  async created () {
    const { data: jsonData } = await axios.get('https://www.csub.edu/data/cms/chrs-maintenance-message.json?nocache' + (new Date()).getTime())
    this.useDefaultMaintMsg = jsonData.useDefault
    this.buttonLoc = jsonData.loginLink
    this.maintenance_start_hour = jsonData.maintenance.startHour
    this.maintenance_end_hour = jsonData.maintenance.endHour
    this.maintMessage = jsonData.maintenance.message
    this.maintenanceDay = jsonData.maintenance.day
    this.allowLogin = jsonData.allowLogin
    this.secondary_message = jsonData.secondary_message
  },

  methods: {
    dispMaint: function () {
      var now = new Date()

      if (this.useDefaultMaintMsg) {
        // Checks day and time on when to display maintenance message.
        if (now.getDay() === this.maintenanceDay && now.getHours() >= parseInt(this.maintenance_start_hour) && now.getHours() < parseInt(this.maintenance_end_hour)) {
          // nothing to do, message is already set to default message
          // Checks day and time on when to disable login button
          if (now.getHours() >= 18 && now.getHours() < this.maintenance_end_hour) {
            this.allowLogin = false
          }
        } else {
          this.maintMessage = ''
        }
      } else {
        this.maintMessage = ''
      }
    }
  },

  updated () {
    // Shows maintenance message
    this.dispMaint()
  }
}
</script>

<style scoped>
  #firstTimeUserPopUp {
    cursor: pointer;
  }

  .btn {
    background: #003595;
    font-family: 'Oswald', sans-serif;
    font-size: 16px !important;
    color: #FFD200;
    /* font-weight: bold !important; */
  }

  .btn:hover {
    color: white !important;
  }
</style>
